module.exports = __webpack_public_path__ + "img/5f_r_musashi@2x.49aae1a2.png";